<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title" *ngIf="_data.action === 'send'">{{
        'CHAT.POPUP.TEMPLATE.SEND' | translate
      }}</span>
      <span class="title dialog-title" *ngIf="_data.action === 'preview'">{{
        'CHAT.POPUP.TEMPLATE.PREVIEW' | translate
      }}</span>
      <button
        mat-icon-button
        (keyup.enter)="matDialogRef.close('send')"
        (click)="matDialogRef.close(null)"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="p-24 m-0">
    <!--  <ng-container *ngIf="(_data.action === 'send' || _data.action === 'preview')">
            <div class="template">
                <div class="template-header">{{_data.template.headerText}}</div>
                <div class="template-body">
                    <p>{{_data.template.bodyText}}</p>
                </div>
                <div *ngIf="_data.template.footerText !== null" class="secondary-text" style="margin-bottom: 5px;">
                    {{_data.template.footerText}}</div>
                <mat-divider *ngIf="_data.template.labelPhone !== null || _data.template.labelUrl !== null">
                </mat-divider>
                <div style="margin-top: 10px;">
                    <div class="template-url-phone" *ngIf="_data.template.labelPhone !== null">
                        <mat-icon style="vertical-align: middle; font-size: 20px" aria-hidden="true">phone
                        </mat-icon> {{_data.template.labelPhone}}
                    </div>
                    <div class="template-url-phone" *ngIf="_data.template.labelUrl !== null">
                        <mat-icon style="vertical-align: middle; font-size: 20px" aria-hidden="true">
                            open_in_new
                        </mat-icon> {{_data.template.labelUrl}}
                    </div>
                </div>
            </div>
        </ng-container> -->

    <preview-template [template]="_data.template"></preview-template>
  </div>

  <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-icon-button
      (click)="matDialogRef.close('send')"
      class="mat-accent"
      aria-label="Close"
      *ngIf="_data.action === 'send'"
      style="
        background-color: #e2ae2f;
        width: 50px;
        height: 50px;
        box-shadow: 3px;
        border-radius: 50%;
      ">
      <mat-icon style="margin: 0px 0px 3px 3px" class="secondary-text"
        >send</mat-icon
      >
    </button>
    <button
      mat-button
      (click)="matDialogRef.close('send')"
      class="add-product-button fuse-white mt-24 mt-md-0"
      aria-label="Close"
      style="background-color: #e2ae2f !important; color: white !important"
      *ngIf="_data.action === 'preview'">
      Aceptar
    </button>
  </div>
</div>
